const TaskCard = ({ task, color, onClick, isEmployee = false }) => (
  <div
    onClick={() => onClick(task)}
    title={isEmployee ? task.client : task.title}
    onMouseEnter={(e) => (e.currentTarget.style.boxShadow = "0 4px 14px rgba(0,0,0,0.14)")}
    onMouseLeave={(e) => (e.currentTarget.style.boxShadow = "0 1px 4px rgba(0,0,0,0.07)")}
    style={{
      borderLeft: `4px solid ${color.border}`,
      background: color.bg,
      borderRadius: "0 8px 8px 0",
      padding: "6px 10px",
      cursor: "pointer",
      minHeight: 64,
      height: "100%",
      boxShadow: "0 1px 4px rgba(0,0,0,0.07)",
      transition: "box-shadow 0.18s",
      display: "flex",
      flexDirection: "column",
      gap: 2,
    }}
  >
    {/* Title row — client name for employee, project name otherwise */}
    <span
      style={{
        fontWeight: 700,
        fontSize: 12,
        color: color.border,
        lineHeight: 1.3,
        overflow: "hidden",
        display: "-webkit-box",
        WebkitLineClamp: 1,
        WebkitBoxOrient: "vertical",
      }}
    >
      {isEmployee ? task.client : task.title}
    </span>

    {/* Client label — hidden for employee */}
    {!isEmployee && (
      <div style={{ fontSize: 10, color: "#6c757d" }}>
        Client :{" "}
        <span style={{ fontWeight: 700, textTransform: "uppercase" }}>{task.client}</span>
      </div>
    )}

    {/* Employee name — hidden for employee */}
    {!isEmployee && (
      <div style={{ fontSize: 11, fontWeight: 600, color: "#343a40" }}>{task.assignedTo}</div>
    )}

    {/* Task description + Task Completed tag */}
    <div style={{
      marginTop: "auto",
      display: "flex",
      alignItems: "flex-end",
      justifyContent: "space-between",
      gap: 4,
    }}>
      <div
        style={{
          fontSize: 10,
          color: "#6c757d",
          fontStyle: "italic",
          overflow: "hidden",
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          lineHeight: 1.45,
          marginTop: 2,
          flex: 1,
        }}
      >
        {task.task}
      </div>
      {task.isTaskCompleted && (
        <span style={{
          flexShrink: 0,
          fontSize: 9,
          fontWeight: 700,
          color: "#0a3622",
          background: "#d1e7dd",
          border: "1px solid #a3cfbb",
          borderRadius: 999,
          padding: "2px 6px",
          letterSpacing: "0.04em",
          whiteSpace: "nowrap",
        }}>
          Task Completed
        </span>
      )}
    </div>
  </div>
);

export default TaskCard;